<template>
  <div class="min-h-screen flex flex-col">
    <Header :menu="menu" v-if="header && header == 'userHeader'" @toggle-menu="toggleMenu" class="sticky top-0 z-40"/>
  
    <div class="flex-1 flex relative">
      <!-- Sidebar -->
      <div 
        class="bg-base-200 dark:bg-neutral-800 transition-all duration-300 ease-in-out"
        :class="{
          'fixed inset-y-0 left-0 z-30 w-[280px] shadow-lg': isMobileView,
          'w-[280px]': !isMobileView,
          'transform -translate-x-full': !isMenuOpen && isMobileView,
          'transform translate-x-0': isMenuOpen && isMobileView,
          'hidden': !menu
        }"
      >
        <div class="h-full overflow-y-auto">
          <Menu v-if="menu && menu == 'userMenu'"/>
          <QuestMenu v-if="menu && menu == 'questMenu'"/>
        </div>
      </div>
  
      <!-- Main Content -->
      <div class="flex-1 flex flex-col min-w-0">
        <div class="flex-1 p-4 lg:p-6">
          <router-view></router-view>  
        </div>
      </div>
    </div>
  
    <!-- Mobile Menu Overlay -->
    <div 
      v-if="isMenuOpen && isMobileView" 
      class="fixed inset-0 bg-black bg-opacity-50 z-20 transition-opacity duration-300 ease-in-out" 
      @click="toggleMenu"
    ></div>
  
    <Footer v-if="footer && footer == 'globalFooter'" class="mt-auto"/>
    <CookieConsent />
  </div>
  
  </template>
  
  <script setup>
  import Header from "./components/header/Header.vue";
  import Footer from "./components/footer/Footer.vue";
  import Menu from "./components/menu/Menu.vue";
  import QuestMenu from "./components/menu/QuestMenu.vue";
  import CookieConsent from "./components/CookieConsent.vue";
  import { useSeo } from './compositions/useSeo'
  
  import { ref, watch, onMounted, onBeforeUnmount } from "vue";
  import { useRoute } from "vue-router";
  import direction from "./utils/direction"
  const route = useRoute();
  const menu  = ref(false);
  const header  = ref(false);
  const footer  = ref(false);
  const isMenuOpen = ref(false);
  const isMobileView = ref(false);
  
  
  const checkMobileView = () => {
    isMobileView.value = window.innerWidth < 1024; // lg breakpoint in Tailwind
    if (!isMobileView.value) {
      isMenuOpen.value = true; // On desktop, menu is always open
    } else {
      isMenuOpen.value = false; // On mobile, menu is closed by default
    }
  };
  
  const toggleMenu = () => {
    if (isMobileView.value) {
      isMenuOpen.value = !isMenuOpen.value;
    }
  };
  
  onMounted(() => {
    checkMobileView();
    window.addEventListener('resize', checkMobileView);
  });
  
  onBeforeUnmount(() => {
    window.removeEventListener('resize', checkMobileView);
  });
  
  useSeo();
  watch(route, (route) => {
    const dir = direction.filter(i => i.page == route.name)[0]
  
    // Sayfayı en üste kaydır
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    window.scrollTo(0, 0);
  
    if(dir){
      menu.value = typeof dir.menu === "undefined" ? direction[0].menu : dir.menu; 
      header.value = typeof dir.header === "undefined" ? direction[0].header : dir.header; 
      footer.value = typeof dir.footer === "undefined" ? direction[0].footer : dir.footer;          
    }else{
      menu.value = direction[0].menu;
      header.value = direction[0].header;
      footer.value = direction[0].footer;
    }
    
    // Sayfa değiştiğinde mobilde menüyü kapat
    if (isMobileView.value) {
      isMenuOpen.value = false;
    }
  });
  </script>
  
  <style>
  .menu-transition {
    transition: all 0.3s ease-in-out;
  }
  
  /* Add smooth transitions for mobile menu */
  .transform {
    transition: transform 0.3s ease-in-out;
  }
  
  /* Hide scrollbar for Chrome, Safari and Opera */
  .overflow-y-auto::-webkit-scrollbar {
    display: none;
  }
  
  /* Hide scrollbar for IE, Edge and Firefox */
  .overflow-y-auto {
    -ms-overflow-style: none;  /* IE and Edge */
    scrollbar-width: none;  /* Firefox */
  }
  
  /* Ensure content doesn't overflow on small screens */
  @media (max-width: 640px) {
    .p-4 {
      padding: 0.75rem;
    }
  }
  </style>